﻿<script setup lang="ts">
    import { $Resources } from '@cwd/lib/main';
    import { inject, onMounted, reactive } from 'vue';
    import { getInvoices, AccountInvoice } from './AccountInvoices.access';
    import Loading from '@shared/components/Loading.vue';
    import { ScopeAccess, vRequireScopeParams } from '@shared/directives/Scope.access';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { FeatureService } from '@shared/directives/Feature.service';
    import { Permissions } from '@shared/Root/Permissions';
    import InvoicesTable from './InvoicesTable.vue';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const scopeAccess: ScopeAccess = injectorAccess.injector.get(ScopeAccess);
    const featureAccess: FeatureService = injectorAccess.injector.get(FeatureService);

    const state = reactive<{
        serviceSubscriptionId: string | null;
        invoices: AccountInvoice[] | null;
        isLoading: boolean;
    }>({
        serviceSubscriptionId: null,
        invoices: null,
        isLoading: false,
    });

    onMounted(async () => {
        state.isLoading = true;

        const requireScopeParams: vRequireScopeParams = {
            Feature: 'Account',
            Permission: Permissions.Read,
        };
        var hasScope = scopeAccess.hasScope(requireScopeParams);

        if (viewModel?.SelectedClientCompany != null) {
            state.serviceSubscriptionId = viewModel.SelectedClientCompany()?.ServiceSubscription.ServiceSubscriptionId();
        }

        if (hasScope) {
            await getInvoices(state.serviceSubscriptionId, featureAccess.hasBackOfficeAccess())
                .then((invoices) => {
                    state.invoices = invoices;
                })
                .finally(() => (state.isLoading = false));
        }
    });
</script>

<template>
    <h2 class="main-title">{{ $Resources.InvoicesTab }}</h2>
    <Loading :show="state.isLoading"></Loading>
    <InvoicesTable v-if="!state.isLoading" :invoices="state.invoices" :serviceSubscriptionId="state.serviceSubscriptionId"></InvoicesTable>
</template>
<style></style>
